import {
  UserProfile,
  Goal,
  FinancialTarget,
  ActionItem,
  AppState,
  NotificationSettings,
  UserPlaybook,
  LifestylePreferences,
  LifeValues,
  LocationOption,
  PrivacyPreferences,
  CommunicationStyle,
} from '../types';

export const initialProfile: UserProfile = {
  name: '',
  currentRole: '',
  currentSalary: 0,
  company: '',
  location: '',
  chosenPath: 'undecided',
  chosenPaths: [],
  targetSalary: 0,
  targetYear: new Date().getFullYear() + 5,
  startDate: new Date().toISOString().split('T')[0],
};

// Empty initial goals - user will create their own via onboarding/playbooks
export const initialGoals: Goal[] = [];

// Empty initial financial targets - user will set their own
export const initialFinancialTargets: FinancialTarget[] = [];

// Empty initial action items - generated by playbooks
export const initialActionItems: ActionItem[] = [];

export const initialNotificationSettings: NotificationSettings = {
  enabled: false,
  dailyReminderTime: '09:00',
  reminderTypes: {
    checkIn: true,
    tasks: true,
    goals: true,
    motivational: true,
  },
};

export const initialUserPlaybooks: UserPlaybook[] = [];

export const initialLifestylePreferences: LifestylePreferences = {
  hobbies: [],
  activityLevel: 'moderate',
  outdoorPreference: 3,
  climatePreference: 'temperate',
  seasonImportance: [],
  workStyle: 'hybrid',
  travelTolerance: 'occasional',
  familyProximityImportance: 3,
  familyLocations: [],
  socialStyle: 'ambivert',
};

export const initialLifeValues: LifeValues = {
  careerGrowth: 4,
  workLifeBalance: 3,
  adventure: 3,
  stability: 3,
  familyTime: 3,
  financialGrowth: 4,
  health: 3,
  community: 2,
};

export const initialLocationOptions: LocationOption[] = [];

export const initialPrivacyPreferences: PrivacyPreferences = {
  showProfilePublic: false,
  shareProgressWithCoach: true,
  allowDataAnalytics: true,
  showActivityStatus: true,
};

export const initialCommunicationStyle: CommunicationStyle = {
  tone: 'balanced',
  detailLevel: 'moderate',
  motivationStyle: 'encouraging',
  responseLength: 'concise',
};

export const initialState: AppState = {
  profile: initialProfile,
  goals: initialGoals,
  dailyCheckIns: [],
  weeklyReviews: [],
  financialEntries: [],
  financialTargets: initialFinancialTargets,
  actionItems: initialActionItems,
  chatHistory: [],
  networkingContacts: [],
  notificationSettings: initialNotificationSettings,
  userPlaybooks: initialUserPlaybooks,
  // Life Planning
  lifestylePreferences: initialLifestylePreferences,
  lifeValues: initialLifeValues,
  locationOptions: initialLocationOptions,
  // Onboarding
  onboardingComplete: false,
  // Phase 1 additions
  privacyPreferences: initialPrivacyPreferences,
  communicationStyle: initialCommunicationStyle,
  financialBaseline: undefined,
  agentPaused: false,
};
